import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { extractAddressComponents } from './address';
import { selectBestResult, isNonUsResult } from './selectBestResult';
/* eslint-disable no-async-promise-executor */

// Address string -> order address fields
export default async function handleGeocode({ address }) {
    return new Promise(async (resolve, reject) => {
        try {
            const toReturn = {};
            const results = await geocodeByAddress(address);

            const best = selectBestResult(results);
            if (!best) {
                throw new Error(`No geocode results for ${address}`);
            }
            const components = best.address_components;

            if (isNonUsResult(best))
                throw new Error(`Geocoding returned non US location ${address} -> ${best.formatted_address}`);

            // Surface partial_match for review
            toReturn.partial_match = !!best.partial_match;

            const premise = components.find((component) => component.types.includes('premise'));

            const { street, city, state, zip } = extractAddressComponents(components);

            if (street) toReturn.street = street;
            if (city) toReturn.city = city;
            if (state) toReturn.state = state;
            if (zip) toReturn.zip = zip;

            if (best.formatted_address) {
                toReturn.fulladdress = best.formatted_address;
                toReturn.address = best.formatted_address;
            }
            if (premise) {
                // Rebuild premise from parsed fields
                const country = components.find((component) => component.types.includes('country'))?.short_name;
                const correctedAddress = [toReturn.street, toReturn.city, toReturn.state, toReturn.zip, country]
                    .filter((part) => !!part)
                    .join(', ');

                if (correctedAddress) {
                    toReturn.fulladdress = correctedAddress;
                    toReturn.address = correctedAddress;
                }
            }

            const { lat, lng } = await getLatLng(best);
            toReturn.lat = lat;
            toReturn.lng = lng;

            resolve(toReturn);
        } catch (err) {
            console.log(err);
            reject(err);
        }
    });
}

// Address string -> best { lat, lng }
export async function geocodeToLatLng(address) {
    const results = await geocodeByAddress(address);
    const best = selectBestResult(results);
    if (!best) throw new Error(`No geocode results for ${address}`);
    return getLatLng(best);
}

// Address string -> best components
export async function geocodeToComponents(address) {
    const results = await geocodeByAddress(address);
    const best = selectBestResult(results);
    return best?.address_components || [];
}
